import React, { useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import '../../../../assests/css/customer/Footer/Cookies.css';
import MyNavbar from "../../Mynavbar/MyNavbar";
import Footer from "../Footer";


const Cookies = () => {
  const [showBanner, setShowBanner] = useState(true);

  const acceptCookies = () => {
    Swal.fire({
      title: "Cookie Preferences Saved",
      text: "Thank you for accepting our cookies. We'll use them to enhance your browsing experience.",
      imageUrl: "https://images.unsplash.com/photo-1499636136210-6f4ee915583e?w=200&h=200&fit=crop",
      imageWidth: 120,
      imageHeight: 120,
      imageAlt: "Cookie icon",
      confirmButtonText: "Continue",
      confirmButtonColor: "#8B7355",
      background: "#fff",
      backdrop: "rgba(0,0,0,0.5)",
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    });

    setShowBanner(false);
  };

  return (
    <>
      <MyNavbar />

      <div className="cookies-page-container">
        {showBanner && (
          <div className="cookie-overlay">
            <div className="cookie-banner">
              <img
                src="https://images.unsplash.com/photo-1499636136210-6f4ee915583e?w=150&h=150&fit=crop"
                alt="Cookie illustration"
                className="cookie-img"
              />

              <div className="cookie-content">
                <h2 className="cookie-title">Cookie Notice</h2>
                <p className="cookie-description">
                  We use cookies to improve your experience on our site and to show you personalized content. By continuing to browse, you agree to our cookie policy.
                </p>

                <div className="cookie-actions">
                  <Link to="/privacy" className="privacy-btn">
                    Privacy Policy
                  </Link>

                  <button className="ok-btn" onClick={acceptCookies}>
                    Accept & Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
};

export default Cookies;